import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotificationAddFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 11C5 8.23148 6.87181 5.90577 9.41197 5.20982C9.14703 4.87163 9 4.45542 9 4C9 2.9 9.9 2 11 2C12.1 2 13 2.9 13 4C13 4.45901 12.8506 4.87819 12.5817 5.2178C15.047 5.92345 16.8349 8.23529 16.9892 10.8785C16.6671 10.8268 16.3367 10.8 16 10.8C12.5758 10.8 9.8 13.5758 9.8 17C9.8 17.6998 9.91594 18.3725 10.1297 19H8.55H3L4.64 14.89C4.88 14.3 5 13.67 5 13.04V11ZM12.0431 21.7733C11.5084 21.3296 11.0495 20.7978 10.6886 20.2001H8.59937C8.90235 21.2397 9.86287 22 10.9999 22C11.3734 22 11.7262 21.9191 12.0431 21.7733ZM21 17C21 19.7614 18.7614 22 16 22C13.2386 22 11 19.7614 11 17C11 14.2386 13.2386 12 16 12C18.7614 12 21 14.2386 21 17ZM13 17.6H15.4V20H16.6V17.6H19V16.4H16.6V14H15.4V16.4H13V17.6Z",
		fill: "currentColor"
	})
});
export default SvgNotificationAddFill;
